import BackgroundDisplay from "../components/background-display";
import Conference from "../components/conference";

const AllConferences = () => {
  return (
    <div>
      <BackgroundDisplay title="Conferences & Events" />
      <Conference />
    </div>
  );
};

export default AllConferences;
